



































    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
    import { Preference } from '@/models/admin/prefrences';
    import { Base } from '@/components/common/base';
    import { IDialogOption } from '@/models/dialog';
    import {getPreferenceListHeaders} from '@/views/admin/preference/preference';
    import {preferenceService} from '@/shared';
import { RoleType } from '@/helper/enum';

    @Component({
        props: ['methodName', 'progress'],
        computed: {
            methodtoCall: {
                get() {
                    return this.$props.methodName;
                },
            },
        },
        components: {
            Grid: () => import('@/components/common/app.grid.vue'),
            AppDialog: () => import('@/components/common/app.dialog.vue'),
        },
    })
    export default class PreferenceListPage extends Base {
        public headers: VHeaders[] = getPreferenceListHeaders(this);
        public pagedPrefernce: Preference[] = [];
        public deleteDialog: IDialogOption = {
            width: 400,
            title: this.$parent.$t('preferences.deleteDialogTitle') as string,
            model: false,
            action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
            loading: false,
            onAction: (): void => {
                this.deletePreference();
            },
        };
        public isSuperAdminRole: boolean = false;
        public preferenceToDelete: Preference = {
            key: '',
            value: '',
        };
        public pagination = new PaginationModel('key');
        public loading: boolean = false;
        public actions: any[] = [];
        public searched: boolean = false;
        public deleted: boolean = false;
        public setActions() {
            this.actions = [
                {
                    type: 'link',
                    icon: 'fas fa-edit',
                    title:  this.$t('preferences.preferencesGirdHeaders.gridAction.edit') as string,
                    action: (model: Preference, storeid: string) => {
                        return { name: 'admin.preferences.edit', params: { key: model.key } };
                    },
                },
                {
                    type: 'button',
                    icon: 'fas fa-trash-alt',
                    title: this.$t('preferences.preferencesGirdHeaders.gridAction.delete') as string,
                    color: 'error',
                    visible: this.isSuperAdminRole,
                    action: (model: Preference, storeid: string) => {
                        this.confirmDelete(model);
                    },
                },
            ];
        }

        public beforeDestroy() {
            const buttons = [];
            this.$emit('updateToolBar', buttons);
        }
        public callMethod(methodName): void {
            if (methodName === 'addPreference') {
                this.$router.push({ name: 'admin.preferences.add' });
            }
        }
        public updateToolBar(): void {
            const buttons: any = [];
            buttons.push({ id: '0', type: 'button', title: this.$t('preferences.btnAddPreference'), disabled: false, visible: true, class: 'btn', label:this.$t('preferences.btnAddPreference'), click: 'addPreference', icon: 'fas fa-plus-circle' });
            this.$emit('updateToolBar', buttons);
        }
        public mounted() {
            // activating tab
            this.$root.$emit('sidebar.layout.vue', 'preferences');

            // Toolbar
            this.updateToolBar();
            this.$watch('methodtoCall', (newVal, oldVal) => {
                if (newVal) {
                    this.callMethod(newVal);
                }
            });
            var role = [RoleType.SuperAdmin.toString()];
            var isRoleAllowed = this.userSession.roles.filter(x => role.includes(x));
            this.isSuperAdminRole = isRoleAllowed.includes('SuperAdmin');
            this.setActions();
            this.getPreferences();
        }

        public async getPreferences(): Promise<void> {
            try {
                this.loading = true;
                const response = await preferenceService.getAllAsync(this.pagination);
                if (response) {
                    this.pagedPrefernce = response.results;
                    this.pagination.totalItems = response.total;
                }
            } finally {
                this.loading = false;
            }

        }
        public updatePaging(paging: any) {
            this.pagination = paging;
        }

        public confirmDelete(item: Preference): void {
            this.deleteDialog.model = true;
            this.preferenceToDelete = item;
        }
        public async deletePreference(): Promise<void> {
            try {
                this.deleteDialog.loading = true;
                const response = await preferenceService.deleteAsync(
                    this.preferenceToDelete.key,
                );
                this.deleted = true;
                this.showAlert(true,  this.$t('preferences.alertDeletePreference'));
                this.getPreferences();
            } finally {
                this.deleteDialog.loading = false;
                this.deleteDialog.model = false;
            }
        }
    }
